import { Link } from "react-router-dom";

export const LogoMark = ({ size = 30 }) => (
  <div
    className="rounded-[9px] bg-primary flex flex-col justify-center gap-1 box-border"
    style={{ width: size, height: size, paddingLeft: size * 0.23 }}
  >
    <div className="h-1 rounded-sm bg-accent" style={{ width: size * 0.53 }} />
    <div className="paper-tex h-1 rounded-sm" style={{ width: size * 0.33 }} />
  </div>
);

export const Logo = ({ to = "/", size = 30, textClass = "text-[28px]", testId }) => (
  <Link to={to} data-testid={testId} className="flex items-center gap-2.5">
    <LogoMark size={size} />
    <span className={`font-heading tracking-tight ${textClass}`}>firstrun</span>
  </Link>
);
